import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../styles/Login.css";

// Firebase
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from "../../firebaseConfig"; // ajusta la ruta si tu firebase está en otro sitio

// Email(s) permitidos como admin — cámbialo por el tuyo
const ADMIN_EMAIL = "dev@alnitak-solutions.com";

const Login = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const handleLogin = async () => {
    setIsLoading(true);
    setError("");
    setSuccessMessage("");
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Si quieres permitir varios admins usa un array includes()
      if (user?.email && user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase()) {
        localStorage.setItem("adminAuthenticated", "true"); // persistencia simple
        setSuccessMessage("Inicio de sesión exitoso. Bienvenido al panel de administración.");

        // Redirige al dashboard (ruta protegida)
        navigate("/admin/dashboard");
      } else {
        setError("No tienes permiso para acceder al panel de administración.");
        // Desloguea por seguridad
        await auth.signOut();
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Error en el inicio de sesión. Inténtalo de nuevo.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Header */}
        <div className="login-header">
          <h1 className="login-title">Panel de Administración</h1>
          <p className="login-subtitle">
            Accede para controlar los pedidos
          </p>
        </div>

        {/* Main */}
        <div className="login-main">
          <button
            onClick={handleLogin}
            disabled={isLoading}
            type="button"
            className="login-button"
          >
            {isLoading ? (
              <>
                <svg
                  className="login-spinner"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="login-spinner-circle"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="login-spinner-path"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Cargando...
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="login-google-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M21.35 11.1h-9.18v2.91h5.38c-.23 1.45-1.62 4.26-5.38 4.26-3.24 0-5.89-2.68-5.89-5.97s2.65-5.97 5.89-5.97c1.84 0 3.07.77 3.77 1.44l2.57-2.49C17.07 3.88 15 3 12.17 3 6.74 3 2.5 7.26 2.5 12.3s4.24 9.3 9.67 9.3c5.6 0 9.3-3.93 9.3-9.47 0-.64-.07-1.13-.12-1.63z" />
                </svg>
                Iniciar sesión con Google
              </>
            )}
          </button>

          {error && (
            <p className="login-error">{error}</p>
          )}
          {successMessage && (
            <p className="login-success">{successMessage}</p>
          )}
        </div>

        {/* Footer */}
        <div className="login-footer">
          <span className="login-footer-text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="login-footer-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 11c0-1.105-.895-2-2-2s-2 .895-2 2v2a2 2 0 104 0v-2zM12 11V7a4 4 0 10-8 0v4"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16 11v2a4 4 0 01-8 0v-2"
              />
            </svg>
            Área segura solo para administradores
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;